import { Slider } from "@/components/ui/slider";

export const Section = ({ title, children, right }) => (
  <div className="border-b border-[#2A2E3D] px-4 py-4">
    <div className="flex items-center justify-between mb-3">
      <h4 className="text-[11px] uppercase font-mono-ui tracking-wider text-slate-400">{title}</h4>{right}
    </div>
    {children}
  </div>
);

export const Param = ({ label, value, min, max, step = 0.01, onChange, testId, unit = "" }) => (
  <div className="grid grid-cols-[86px_1fr_52px] items-center gap-3 py-1.5">
    <span className="text-xs text-slate-300 truncate">{label}</span>
    <Slider value={[value]} min={min} max={max} step={step} onValueChange={([v]) => onChange(v)} data-testid={testId} />
    <span className="font-mono-ui text-[10px] text-right text-slate-400 whitespace-nowrap" data-testid={`${testId}-value`}>{(+value).toFixed(2)}{unit}</span>
  </div>
);
